export enum ERouteName {
    CAMPAIGN_DATA = 'campaign-data',
    CAMPAIGN_DRAW = 'campaign-draw',
    CAMPAIGN_PRIZE = 'campaign-prize',
    CAMPAIGN_PROMO_PRODUCTS = 'campaign-promoProducts',
    CAMPAIGN_EMAILS = 'campaign-emails',
    CAMPAIGN_FAQ = 'campaign-faq',
    CAMPAIGN_TEAM = 'campaign-team',
    HIVE_EDIT = 'editHive',
    HIVE_CAMPAIGN_EDIT = 'editHiveCampaign',
    SETTINGS_ACCOUNT = 'accountSettings',
    SETTINGS_ORGANIZATION = 'organizationSettings'
}
